import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import LoginForm from "./LoginForm";
import settings from "settings";

function Login() {
	return (
		<div className="flex flex-col flex-auto items-center justify-center shrink-0 p-16 md:p-24">
			<motion.div
				initial={{ opacity: 0, scale: 0.6 }}
				animate={{ opacity: 1, scale: 1 }}
				className="flex w-full max-w-400 md:max-w-3xl rounded-20 shadow-2xl overflow-hidden"
			>
				<Card
					className="Login-leftSection flex flex-col w-full items-center justify-center shadow-0"
					square
				>
					<CardContent className="flex flex-col items-center justify-center w-full py-96 max-w-320">
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1, transition: { delay: 0.2 } }}
						>
							<div className="flex items-center mb-48">
								<div>
									<Typography
										className="text-24 font-semibold logo-text"
										color="inherit"
									>
										Login
									</Typography>
								</div>
							</div>
						</motion.div>
						<LoginForm />
					</CardContent>

					<div className="flex flex-col items-center justify-center pb-32">
						<div>
							<span className="font-normal mr-8">Don't have an account?</span>
							<a href={settings.urls.register} className="font-normal">
								Create account
							</a>
						</div>
					</div>
				</Card>
			</motion.div>
		</div>
	);
}

export default Login;
